import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  fileErrorSelector,
  jobErrorSelector,
  productErrorSelector,
  userErrorSelector,
} from 'store/selectors';
import toast from 'react-hot-toast';

const Errors = () => {
  const userError = useSelector(userErrorSelector);
  const jobError = useSelector(jobErrorSelector);
  const productError = useSelector(productErrorSelector);
  const fileError = useSelector(fileErrorSelector);

  useEffect(() => {
    if (userError) {
      toast.error(userError?.message);
    }
  }, [userError]);

  useEffect(() => {
    if (jobError) {
      toast.error(jobError?.message);
    }
  }, [jobError]);

  useEffect(() => {
    if (productError) {
      toast.error(productError?.message);
    }
  }, [productError]);

  useEffect(() => {
    if (fileError) {
      toast.error(fileError?.message);
    }
  }, [fileError]);

  return null;
};

export default Errors;
